<template>
  <VContent>
    <template slot="right">
      <span>طلبات النشر</span>
    </template>
    <template slot="left">
      <b-button variant="info" size="md" class="text-light" @click="approveAll">
        الموافقة على الكل
      </b-button>
    </template>
    <template slot="content">
      <div class="d-flex align-items-center mb-3">
        <b-form-select
          id="bank-filter"
          v-model="selectedBankId"
          :options="banks"
          @change="getAll"
          class="flex-grow-1"
        ></b-form-select>
        <b-button
          variant="danger"
          size="sm"
          class="mr-2"
          @click="clearFilter"
          title="Clear Filter"
        >
          <b-icon icon="x-circle"></b-icon>
        </b-button>
      </div>
      <b-table
        :items="items"
        :fields="fields"
        :tbody-transition-props="transProps"
        tbody-tr-class="text-muted"
        responsive
        table-class="table-font h-100"
      >
        <!-- ...existing code... -->
      </b-table>
    </template>
    <template slot="modals">
      <BankModal :readonly="readonly" @close="readonly = false"></BankModal>
    </template>
    <template slot="bottom">
      <b-pagination
        v-model="page"
        :current-page="meta.current_page"
        :per-page="meta.per_page"
        :total-rows="meta.last_page * meta.per_page"
      ></b-pagination>
    </template>
  </VContent>
</template>

<script>
import BankModal from "./components/bankModal";
import {
  successAlert,
  errorAlert,
  showAlertWithConfirm,
  ImageURL,
} from "@/utils/helper";

export default {
  components: { BankModal },
  data() {
    return {
      readonly: false,
      page: 1,
      searchPhone: "",
      searchName: "",
      selectedBankId: null,
      banks: [],
      transProps: {
        name: "flip-list",
      },
      fields: [
        {
          key: "id",
          label: "أ",
          sortable: true,
        },
        {
          key: "requested_by",
          label: "المستخدم",
          sortable: true,
        },
        {
          key: "bank",
          label: "المصرف",
          sortable: true,
        },
        {
          key: "action_type",
          label: "نوع العملية",
          sortable: true,
        },
        {
          key: "table_name",
          label: "اسم الجدول",
          sortable: true,
        },
        {
          key: "old_value",
          label: "القيمة القديمة",
          sortable: true,
        },
        {
          key: "new_value",
          label: "القيمة الجديدة",
          sortable: true,
        },
        {
          key: "status",
          label: "الحالة",
          sortable: true,
        },
        {
          key: "requested_at",
          label: "تاريخ الطلب",
          sortable: true,
        },
        {
          key: "actions",
          label: "العمليات",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.state.admin.auditLogs.list;
    },
    meta() {
      return this.$store.state.admin.auditLogs.meta;
    },
  },
  watch: {
    page() {
      this.getAll();
    },
  },
  mounted() {
    this.getAll();
    this.fetchBanks();
  },
  methods: {
    clearFilter() {
      this.selectedBankId = null;
      this.getAll();
    },
    getAll() {
      this.$store.dispatch("admin/auditLogs/get", {
        page: this.page,
        phone: this.searchPhone,
        name: this.searchName,
        bank_id: this.selectedBankId,
      });
    },
    fetchBanks() {
      this.$store.dispatch("admin/banks/getAll").then((response) => {
        this.banks = response.map((bank) => ({
          value: bank.id,
          text: bank.name,
        }));
      });
    },
    getByID(id, status) {
      this.$store
        .dispatch("admin/auditLogs/show", id)
        .then(() => {
          this.readonly = status;
          this.$bvModal.show("bank-modal");
        })
        .catch(() => errorAlert());
    },
    approve(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("admin/auditLogs/approve", id)
            .then(() => {
              successAlert();
              this.getAll();
            })
            .catch((error) =>
              errorAlert(error.response ? error.response.data.message : "فشل")
            );
        }
      });
    },
    approveAll(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("admin/auditLogs/approveAll")
            .then(() => {
              successAlert();
              this.getAll();
            })
            .catch((error) =>
              errorAlert(error.response ? error.response.data.message : "فشل")
            );
        }
      });
    },
    reject(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("admin/auditLogs/reject", id)
            .then(() => {
              successAlert();
              this.getAll();
            })
            .catch((error) =>
              errorAlert(error.response ? error.response.data.message : "فشل")
            );
        }
      });
    },
    getFilteredOldValues(item) {
      if (item.old_value && item.new_value) {
        return Object.keys(item.old_value)
          .filter(
            (key) =>
              key !== "id" &&
              key !== "created_at" &&
              key !== "updated_at" &&
              key !== "bank_id" &&
              key !== "status" &&
              item.old_value[key] != item.new_value[key]
          )
          .reduce((result, key) => {
            result[key] = item.old_value[key];
            return result;
          }, {});
      } else if (item.old_value) {
        return Object.keys(item.old_value)
          .filter(
            (key) =>
              key !== "id" &&
              key !== "created_at" &&
              key !== "updated_at" &&
              key !== "bank_id" &&
              key !== "status"
          )
          .reduce((result, key) => {
            result[key] = item.old_value[key];
            return result;
          }, {});
      } else {
        return {};
      }
    },
    getFilteredNewValues(item) {
      if (item.new_value && item.old_value) {
        return Object.keys(item.new_value)
          .filter(
            (key) =>
              key !== "id" &&
              key !== "created_at" &&
              key !== "updated_at" &&
              key !== "bank_id" &&
              key !== "status" &&
              item.new_value[key] != item.old_value[key]
          )
          .reduce((result, key) => {
            result[key] = item.new_value[key];
            return result;
          }, {});
      } else if (item.new_value) {
        return Object.keys(item.new_value)
          .filter(
            (key) =>
              key !== "id" &&
              key !== "created_at" &&
              key !== "updated_at" &&
              key !== "bank_id" &&
              key !== "status"
          )
          .reduce((result, key) => {
            result[key] = item.new_value[key];
            return result;
          }, {});
      } else {
        return {};
      }
    },
    translateKey(key) {
      const translations = {
        action_type: "نوع العملية",
        approved_at: "تاريخ الموافقة",
        approved_by: "تمت الموافقة بواسطة",
        bank: "المصرف",
        id: "رقم التعريف",
        lat: "خط العرض",
        lng: "خط الطول",
        new_value: "القيمة الجديدة",
        old_value: "القيمة القديمة",
        record_id: "رقم السجل",
        rejected_at: "تاريخ الرفض",
        rejected_by: "تم الرفض بواسطة",
        requested_at: "تاريخ الطلب",
        requested_by: "تم الطلب بواسطة",
        status: "الحالة",
        table_name: "اسم الجدول",
        phone: "رقم الهاتف",
        email: "البريد الالكتروني",
        address: "العنوان",
        name: "الاسم",
        type: "النوع",
        created_at: "تاريخ الانشاء",
        updated_at: "تاريخ التعديل",
        website: "الموقع الالكتروني",
        logo: "الشعار",
        cover: "الغلاف",
        about: "نبذة عن",
        location: "العنوان",
        image: "الصورة",
        advantages_and_conditions: "المزايا والشروط",
        fees_and_commissions: "الرسوم والعمولات",
        benefit: "الفائدة",
        conditions: "الشروط",
        limits: "الحدود",
        mechanism: "الآلية",
        payment_mechanism: "آلية الدفع",
        period: "الفترة",
        warranties: "الضمانات",
        text: "المحتوى",
        procedures: "الإجراءات",
        legal_framework: "الإطار القانوني",
        documents: "المستندات",
        terms_and_conditions: "الشروط والأحكام",
        governate: "المحافظة",
        district: "المنطقة",
        branch: "الفرع",
        phone: "الهاتف",
        name: "الاسم",
      };
      return translations[key] || key;
    },
  },
};
</script>

<style lang="scss">
td[aria-colindex="1"] {
  text-align: right;
}

td[aria-colindex="2"] {
  text-align: center;
}

td[aria-colindex="3"] {
  direction: ltr;
}

td[aria-colindex="5"] {
  overflow-x: hidden;
  width: 200px;
}
</style>
